export default __webpack_public_path__ + "static/media/loadingIcon.8b443926.svg";